/** Closed set of error classification slugs. Never free text derived from the error message. */
export type ErrorKind =
    | 'out-of-memory'
    | 'chunk-load'
    | 'pdf-parse'
    | 'pdf-encrypted'
    | 'network'
    | 'aborted'
    | 'unknown';

/**
 * Map any thrown value to a bounded ErrorKind slug.
 * Matches by error name and known message shapes; anything unrecognised
 * returns 'unknown' -- raw message text NEVER leaks into the return value.
 */
export function classifyError(err: unknown): ErrorKind {
    if (!(err instanceof Error)) return 'unknown';

    const { name, message } = err;

    if (name === 'ChunkLoadError') return 'chunk-load';
    if (name === 'PasswordException') return 'pdf-encrypted';
    if (name === 'InvalidPDFException' || name === 'UnexpectedResponseException') return 'pdf-parse';
    if (name === 'AbortError') return 'aborted';

    if (err instanceof RangeError && /allocation|out of memory/i.test(message)) return 'out-of-memory';
    if (err instanceof TypeError && /failed to fetch/i.test(message)) return 'network';

    return 'unknown';
}
